/**
 * Quando a conversa ao vivo fica acordada. O cochilo existe para não gastar
 * minutos com ninguém falando; o que o segura são o Secretário falando,
 * trabalho em andamento, fala que virou texto e, desde 06/10, a própria pessoa
 * falando por mais de um segundo seguido (uma história longa não vira cochilo).
 * Ruído constante sem nenhuma palavra reconhecida por dois minutos deixa de
 * contar: aí é a TV, não a pessoa.
 */
export const DOZE_AFTER_MS = 25_000;
/** Volume acima do ruído por este tempo seguido conta como fala. */
export const SPEECH_HOLD_MS = 1200;
/** Sem nenhuma palavra reconhecida por este tempo, "ouvindo" deixa de segurar a conversa. */
export const NOISE_CAP_MS = 120_000;

export type AwakeInput = {
  /** Fase do momento: 'listening' e 'hearing' são as que podem cochilar. */
  phase: string;
  /** Há quanto tempo o volume está acima do ruído, sem parar (0 = agora não está). */
  loudForMs: number;
  /** Há quanto tempo a última fala virou texto. */
  sinceTranscriptMs: number;
};

/** A conversa está ativa agora (o relógio do cochilo volta ao zero)? */
export function isActive({ phase, loudForMs, sinceTranscriptMs }: AwakeInput): boolean {
  if (phase !== 'listening' && phase !== 'hearing') return true;
  return loudForMs >= SPEECH_HOLD_MS && sinceTranscriptMs <= NOISE_CAP_MS;
}
